import { ProgressBar } from "primereact/progressbar";
import localeText from "../../../../../locale";
import { normalizeExtracoinUsagePercent } from "../../../utils/extracoinUsagePercent";

export function getGoal(currentPercent) {
  const p = Number(currentPercent) || 0;
  if (p < 15) return 15;
  if (p < 30) return 30;
  if (p < 50) return 50;
  if (p < 70) return 70;
  if (p < 90) return 90;
  return 100;
}

const PowerOfUseGoals = ({ currentPercent, userTypeInfo, titleKey, descriptionKey }) => {
  const percent = normalizeExtracoinUsagePercent(currentPercent);
  const goal = getGoal(percent);
  const isManager = /manager/i.test(userTypeInfo || "");
  const isCustomer = /customer/i.test(userTypeInfo || "");

  const title = titleKey
    ? (localeText(titleKey) || "Meta")
    : (localeText("powerOfUse") || "Poder de uso");
  const description =
    descriptionKey === ""
      ? ""
      : descriptionKey
        ? (localeText(descriptionKey)?.replace("{percent}", percent) || "")
        : (localeText("powerOfUseDescription")?.replace("{percent}", percent) ||
            `Pague até ${percent}% de suas compras usando seu saldo de Extracréditos.`);

  return (
    <>
      <div className="font-semibold mb-2 m-0" style={{ color: "var(--theme-text, #172B4D)" }}>
        {title}
      </div>
      {description && (
        <p className="text-xs mb-3 m-0" style={{ color: "var(--theme-text-muted, #7A869A)" }}>
          {description}
        </p>
      )}
      <div className="mb-2">
        <div className="flex justify-content-between mb-1">
          <span className="text-sm font-medium" style={{ color: "var(--theme-primary, #1DAF61)" }}>
            {percent}% {localeText("unlocked") || "liberado"}
          </span>
          <span className="text-sm font-semibold" style={{ color: "var(--theme-text-muted, #505F79)" }}>
            {localeText("goal") || "Meta"} {goal}%
          </span>
        </div>
        <ProgressBar
          value={percent}
          showValue={false}
          style={{ height: "8px" }}
          pt={{
            value: { style: { backgroundColor: "var(--theme-primary, #1DAF61)" } },
          }}
        />
      </div>
      {goal > percent && !isCustomer && (
        <div
          className="p-2 border-round-md mt-2"
          style={{ backgroundColor: "color-mix(in srgb, var(--theme-border) 40%, transparent)" }}
        >
          <div className="text-sm mb-1 font-semibold" style={{ color: "var(--theme-text, #344563)" }}>
            {localeText("unlockMore") || "Desbloqueie +"} {isManager ? "2%" : "1%"}
          </div>
          <div className="text-xs" style={{ color: "var(--theme-text-muted, #344563)" }}>
            {isManager
              ? localeText("powerOfUseManagerUnlock") ||
                "Convide novos Partners (pagas, não via voucher) para aumentar seu limite."
              : localeText("powerOfUseOtherUnlock") ||
                "Convide novos Partners pagos para aumentar seu limite."}
          </div>
        </div>
      )}
    </>
  );
};

export default PowerOfUseGoals;
